<template>
  <div
    style="background-image: linear-gradient(90deg, #ffdc77 0%, #ffccd5 100%)"
  >
    <div
      v-if="loading"
      class="d-flex vertical-center justify-content-center align-items-center"
      style="height: 85vh; dislay: flex"
    >
      <LoadingMDL />
    </div>
    <div
      v-else
      class="position"
      style="
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding-top: 7%;
        padding-left: 5%;
        padding-right: 5%;
        padding-bottom: 10%;
      "
    >
      <div
        class="block_card"
        v-for="(index, value) in content.length"
        :key="index"
      >
        <div class="container_card">
          <div v-if="!checkingDisable(index)" class="bg-image">
            <div class="addBlur"></div>
            <div class="lock">
              <i style="color: #89abe6" class="fas fa-lock fa-5x"></i>
            </div>
          </div>

          <Card
            class="card"
            :imgUrl="baseUrl + '' + content[value].icon.enable.data"
            :_height="70"
            :_width="70"
          >
          </Card>
        </div>
        <div style="margin-top: 10%; height: 20%">
          <div style="text-align: center">
            <h4 style="color: #89abe6">
              {{ checkLanguage(content[value].title) }}
            </h4>
          </div>

          <div
            :class="returnClassBtnStart(index)"
            @click="btnClicked(index, returnTextStart(index).toUpperCase())"
          >
            <div>
              <div style="font-size: 16px">
                {{ returnTextStart(index).toUpperCase() }}
              </div>
            </div>
            <div v-if="returnTextStart(index).toUpperCase() != 'LOCKED'">
              <img
                src="/icons/play-arrow.svg"
                style="object-fit: contain; width: 30%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/elements/Card';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  components: {Card, LoadingMDL},
  name: 'LS04',
  props: {},
  data() {
    return {
      content: [],
      loading: true,
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      menuLock: [],
    };
  },
  methods: {
    onLoadData() {
      this.lang =
        this.$store.getters['language/getLanguage'] == null
          ? 'EN'
          : this.$store.getters['language/getLanguage'];

      const codeTemplate = 'LS01-1';
      this.$store.dispatch('v3/fetchTemplateByCode', codeTemplate);
    },
    btnClicked(index, status) {
      if (status == 'START') {
        this.$router.push('/v4/LS03/' + index);
      }
    },
    returnTextStart(index) {
      let isLock = this.checkingDisable(index);
      if (isLock == true) {
        return 'start';
      } else {
        return 'locked';
      }
    },
    returnClassBtnStart(index) {
      let isLock = this.checkingDisable(index);
      if (isLock == true) {
        return 'button button_practiceActive';
      } else {
        return 'button button_practiceUnActive';
      }
    },
    checkingDisable(params) {
      for (let i = 0; i < this.menuLock.length; i++) {
        if (this.menuLock[i].number == params) {
          if (this.menuLock[i].lock) {
            return false;
          } else {
            return true;
          }
        }
      }
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.lang.toUpperCase()) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error!!');
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      getLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      let store = [];
      const template = val.templates[0];
      template.content.item.forEach((el) => {
        if (el.position == 'middle') {
          store.push(el);
        }
      });

      this.content = store;
      this.menuLock = this.$store.getters['necessary/getMenuLockChinese2'];
      this.loading = false;
    },
    getLanguage: function () {
      location.reload();
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: row;
}
.container_card {
  width: 100%;
  height: 65%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  position: relative;
}
.bg-image {
  position: absolute;
  z-index: 1;
  height: 90%;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  align-self: center;
  justify-content: center;
  align-items: center;
}
.addBlur {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  backdrop-filter: blur(5px);
  min-height: 85%;
  min-width: 100%;
}

.lock {
  z-index: 2;
  margin: 0;
  position: absolute;
}

.block {
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 7px;
}
.card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  background-color: white;
  margin-top: 15%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
}
.button_practiceActive {
  background-color: #f1b205;
  color: white;
  font-size: 10px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 1rem;
  width: 160px;
  height: 50px;
}
.button_practiceUnActive {
  background-color: #bebebe;
  color: white;
  font-size: 10px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 1rem;
  width: 160px;
  height: 50px;
}

.button_play {
  background-color: #ed8e91;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 25%;
  width: 250px;
  height: 70px;
}
* {
  user-select: none;
}
.block_card {
  width: 17%;
  margin-left: 45px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .block_card {
    width: 85%;
    margin-left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .card {
    height: 100%;
  }
  .button_practice {
    height: 60px;
  }
  .button_play {
    height: 60px;
  }
  .addBlur {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    backdrop-filter: blur(5px);
    min-height: 100%;
    min-width: 100%;
  }
}
// resolution ipad
@media only screen and (min-width: 600px) and (max-width: 1366px) {
  .bg-image {
    position: absolute;
    z-index: 1;
    height: 80%;
    width: 100%;
    position: absolute;
    bottom: 10%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
  .bg-image {
    bottom: 0;
  }
  .addBlur {
    height: 90%;
    position: absolute;
    bottom: 15%;
  }
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1800px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }
}

// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
